import { endpoints } from './endpoints'
import request from '../request'

export function createComplaint(data) {
  return request({
    url: endpoints.createComplaint,
    method: 'post',
    data,
  })
}